'use client';

import CssBaseline from '@mui/material/CssBaseline';
import { ThemeProvider } from '@mui/material/styles';
import { AppRouterCacheProvider } from '@mui/material-nextjs/v14-appRouter';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { SessionProvider } from 'next-auth/react';
import { NavigationGuardProvider } from 'next-navigation-guard';
import { SnackbarProvider } from "notistack";
import { useState } from 'react';

import { theme } from './theme';

export function Providers({ children }: { children: React.ReactNode }) {
  const [queryClient] = useState(() => new QueryClient());

  return (
    <QueryClientProvider client={queryClient}>
      <SessionProvider>
        <NavigationGuardProvider>
          <AppRouterCacheProvider>
            <ThemeProvider theme={theme}>
              <LocalizationProvider dateAdapter={AdapterDateFns}>
                <SnackbarProvider
                  maxSnack={3}
                  anchorOrigin={{
                    vertical: 'bottom',
                    horizontal: 'right',
                  }}
                >
                  <CssBaseline />
                  {children}
                </SnackbarProvider>
              </LocalizationProvider>
            </ThemeProvider>
          </AppRouterCacheProvider>
        </NavigationGuardProvider>
      </SessionProvider>
    </QueryClientProvider>
  );
} 